/**
 * @generated SignedSource<<98a4126a66181f6c7cc4f3cc26cdcb8a>>
 * @relayHash ff4d091d96c84ca8c39277a86d58244b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d9990b9dc884ef7836d9ee434f48470b0d93787f7109b909380fd4a028d55917

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraReplaceIssueSearchViewFieldSetsInput = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  inclusive?: boolean | null | undefined;
  nodes: ReadonlyArray<string>;
};
export type JiraIssueSearchViewFieldSetsContext = {
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraFieldSetsMutationInput = {
  replaceFieldSetsInput?: JiraReplaceIssueSearchViewFieldSetsInput | null | undefined;
  resetToDefaultFieldSets?: boolean | null | undefined;
};
export type main_replaceListViewFieldSetsMutation$variables = {
  amountOfColumns: number;
  fieldSetsInput?: JiraFieldSetsMutationInput | null | undefined;
  id: string;
  includeView: boolean;
  input?: JiraReplaceIssueSearchViewFieldSetsInput | null | undefined;
};
export type main_replaceListViewFieldSetsMutation$data = {
  readonly jira: {
    readonly replaceIssueSearchViewFieldSets: {
      readonly success: boolean;
      readonly view?: {
        readonly viewId: string | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_ListView_view">;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type main_replaceListViewFieldSetsMutation$rawResponse = {
  readonly jira: {
    readonly replaceIssueSearchViewFieldSets: {
      readonly success: boolean;
      readonly view: {
        readonly fieldSets: {
          readonly __id?: string;
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly displayName: string | null | undefined;
              readonly fieldSetId: string | null | undefined;
              readonly fieldSetPreferences: {
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly fieldType: {
                readonly displayName: string | null | undefined;
              } | null | undefined;
              readonly isSortable: boolean | null | undefined;
              readonly jqlTerm: string | null | undefined;
              readonly type: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
          readonly totalCount: number | null | undefined;
        } | null | undefined;
        readonly hasDefaultFieldSets: boolean | null | undefined;
        readonly id: string;
        readonly viewId: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type main_replaceListViewFieldSetsMutation = {
  rawResponse: main_replaceListViewFieldSetsMutation$rawResponse;
  response: main_replaceListViewFieldSetsMutation$data;
  variables: main_replaceListViewFieldSetsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amountOfColumns"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeView"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v5 = [
  {
    "kind": "Variable",
    "name": "fieldSetsInput",
    "variableName": "fieldSetsInput"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "success"
},
v7 = {
  "kind": "ScalarField",
  "name": "viewId"
},
v8 = {
  "kind": "ScalarField",
  "name": "displayName"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "main_replaceListViewFieldSetsMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraIssueSearchViewPayload",
            "kind": "LinkedField",
            "name": "replaceIssueSearchViewFieldSets",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "condition": "includeView",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueSearchView",
                    "kind": "LinkedField",
                    "name": "view",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_ListView_view"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "main_replaceListViewFieldSetsMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraIssueSearchViewPayload",
            "kind": "LinkedField",
            "name": "replaceIssueSearchViewFieldSets",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "condition": "includeView",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueSearchView",
                    "kind": "LinkedField",
                    "name": "view",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasDefaultFieldSets"
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "fieldSetSelectedState": "SELECTED"
                            }
                          },
                          {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "amountOfColumns"
                          }
                        ],
                        "concreteType": "JiraIssueSearchFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "totalCount"
                          },
                          {
                            "concreteType": "JiraIssueSearchFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueSearchFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "fieldSetId"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "type"
                                  },
                                  (v8/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "jqlTerm"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "isSortable"
                                  },
                                  {
                                    "concreteType": "JiraFieldSetPreferences",
                                    "kind": "LinkedField",
                                    "name": "fieldSetPreferences",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "width"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "JiraFieldType",
                                    "kind": "LinkedField",
                                    "name": "fieldType",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__id"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d9990b9dc884ef7836d9ee434f48470b0d93787f7109b909380fd4a028d55917",
    "metadata": {},
    "name": "main_replaceListViewFieldSetsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "9be997dbbfbbbdee8b96e0b00eeacd80";

export default node;
